import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

/* Sprite-backed: the header draws it twice and every suggestion row once; see `IconSprite`. */
export const Search = (props: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.search}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    />
  );
};
